export default __webpack_public_path__ + "static/media/img6.dde30065.png";